import { defineStore } from 'pinia'
import { LocalConfig } from '@velociti/core'

export const useConfigStore = defineStore('config', {
  state: (): LocalConfig => {
    return {
      tenant: null,
    }
  },
  getters: {
    isTenantSet: (state) => !!state.tenant,
    tenantConfigUrl: (state) => `${state.tenant.url}/api/tenant/config`,
  },
  persist: {
    enabled: true,
  },
})
